import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "group"]

  connect() {
    this.update()
  }

  update() {
    this.groupTargets.forEach((group) => {
      const visible = group.dataset.condition === this.sourceTarget.value
      group.hidden = !visible
      group.querySelectorAll("input, select, textarea, button").forEach((field) => {
        field.disabled = !visible
      })
    })
  }
}
